import api from './api'

export default {
  getAll(params = {}) {
    return api.get('/admin/notifications', { params })
  },

  getStats() {
    return api.get('/admin/notifications/stats')
  },

  getTypes() {
    return api.get('/admin/notifications/types')
  },

  delete(id) {
    return api.delete(`/admin/notifications/${id}`)
  },
}
